import type {CSSProperties} from 'react';
import {getScoreLabel} from '@/components/report/score-ring';
import outline from '../../../../config/bite-report-outline.json';

export function biteAssessment(score:number) {
  const value=Math.max(0,Math.min(100,score)),tier=Math.min(4,Math.floor(value/20));
  return {value,tier,label:outline.scoreLabels[tier]};
}

export function BiteReportScoreScale({score,variant='document',label='종합 평가'}:{score:number;variant?:'document'|'assessment';label?:string}) {
  const {value,tier}=biteAssessment(score);
  const labels=variant==='assessment'?outline.scoreLabels:Array.from({length:5},(_,index)=>getScoreLabel(index*20));
  return <div className={`bite-report-scale bite-report-scale--${variant}`} style={{'--bite-score-position':`${value}%`} as CSSProperties}>
    <meter min={0} max={100} value={value} aria-label={label} aria-valuetext={`${value}점, 100점 만점, ${labels[tier]}`}/>
    <div className="bite-report-scale__visual" aria-hidden="true">
      <span className="bite-report-scale__marker">{value}{variant==='assessment'&&<small> / 100</small>}</span>
      <div className="bite-report-scale__segments">{labels.map((label,index)=><span key={label} data-active={index===tier}/>)}</div>
      <div className="bite-report-scale__labels">{labels.map((label,index)=><span key={label} data-active={index===tier}>{label}</span>)}</div>
    </div>
  </div>;
}
